export default "__VITE_ASSET__Bw$YjL3X__"